import React, { useState } from "react";

import { useNavigate } from "react-router-dom";

import {
  productNameFieldInformation,
  matchingStringFieldInformation,
  quantityFieldInformation,
} from "../data/productFieldsInformation";
import {
  Form,
  Table,
  DatePicker,
  Select,
  Button,
  Popconfirm,
  Popover,
  message,
  Skeleton,
  Input,
  Spin,
  InputNumber,
} from "antd";

import { createProduct } from "../utils/fetchProducts";
// Import question mark icon
import { QuestionCircleOutlined, InfoCircleOutlined } from "@ant-design/icons";

import api from "../api/axios";

import { useStateContext } from "../contexts/ContextProvider";

const CreateProducts = () => {
  const { loadingMessage, setLoadingMessage } = useStateContext();

  const navigate = useNavigate();

  const baseUrl = `${window.location.protocol}//${window.location.host}`;

  // Handling errors
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (values) => {
    try {
      setIsSubmitting(true);
      const product = await createProduct(values);
      message.success("Producto creado correctamente");
      navigate(`/products/${product.created_id}`);
    } catch (error) {
      console.error("Error", error);
      message.error("Error al crear el producto");
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <>
      <div className=" bg-white dark:bg-main-dark-bg rounded-3xl">
        {/* Showing data saved correctly */}
        <div className="mb-5 flex justify-between">
          <div className="font-bold text-3xl my-5">Crear Producto</div>
        </div>
        <div className="max-w-[800px]">
          <Form onFinish={handleSubmit}>
            <Form.Item
              label={productNameLabel}
              name="name"
              rules={[{ required: true, message: "El nombre es requerido" }]}
            >
              <Input autoComplete="off" disabled={isSubmitting} />
            </Form.Item>
            <Form.Item
              label={matchingStringLabel}
              name="matching_string"
              rules={[
                { required: true, message: "El matching string es requerido" },
              ]}
            >
              <Input autoComplete="off" disabled={isSubmitting} />
            </Form.Item>
            <Form.Item
              label={quantityLabel}
              name="quantity"
              rules={[{ required: true, message: "La cantidad es requerida" }]}
            >
              <InputNumber autoComplete="off" disabled={isSubmitting} />
            </Form.Item>
            <div className="mt-10">
              <Button type="primary" htmlType="submit" loading={isSubmitting}>
                Crear producto
              </Button>{" "}
              {/* Add information icon */}
              <div className="text-sm text-gray-500 italic mt-2">
                <InfoCircleOutlined />{" "}
                <span className="ml-2">
                  Una vez creado el producto podras añadir más información, como
                  variantes, precios, entre otros.
                </span>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </>
  );
};

export default CreateProducts;

// Labels
const productNameLabel = (
  <div className="flex gap-2">
    <div>Nombre</div>
    <Popover content={productNameFieldInformation} className="cursor-pointer">
      <QuestionCircleOutlined />
    </Popover>
  </div>
);

const matchingStringLabel = (
  <div className="flex gap-2">
    <div>Matching String</div>
    <Popover
      content={matchingStringFieldInformation}
      className="cursor-pointer"
    >
      <QuestionCircleOutlined />
    </Popover>
  </div>
);

const quantityLabel = (
  <div className="flex gap-2">
    <div>Formato / Cantidad</div>
    <Popover content={quantityFieldInformation} className="cursor-pointer">
      <QuestionCircleOutlined />
    </Popover>
  </div>
);
